import type { AuditEvent, Role } from "../../types";

export const behaviorEventNames = [
  "first_import",
  "supplier_contact_added",
  "first_item",
  "first_order",
  "first_quote",
  "price_benchmark_used",
  "supplier_response",
  "quote_accepted",
  "invoice_matched",
  "issue_resolved",
  "reorder_completed",
  "time_to_repeat_order",
] as const;

export type BehaviorEventName = (typeof behaviorEventNames)[number];

export type BehaviorEventProperties = Record<string, string | number | boolean | null | undefined>;

export interface BehaviorEventInput {
  actor?: string;
  entity: string;
  market: string;
  name: BehaviorEventName;
  properties?: BehaviorEventProperties;
  role: Role;
  step?: string;
}

export const behaviorEventLabels: Record<BehaviorEventName, string> = {
  first_import: "First import",
  supplier_contact_added: "Supplier contact added",
  first_item: "First item",
  first_order: "First order",
  first_quote: "First quote",
  price_benchmark_used: "Price benchmark used",
  supplier_response: "Supplier response",
  quote_accepted: "Quote accepted",
  invoice_matched: "Invoice matched",
  issue_resolved: "Issue resolved",
  reorder_completed: "Reorder completed",
  time_to_repeat_order: "Time to repeat order",
};

export function behaviorActionFor(name: BehaviorEventName) {
  return `Behavior: ${behaviorEventLabels[name]}`;
}

export function behaviorElapsedSeconds(startedAt: number | null, endedAt = Date.now()) {
  if (!startedAt || endedAt <= startedAt) {
    return null;
  }

  return Math.round((endedAt - startedAt) / 1000);
}

export function hasRecordedBehaviorEvent(events: AuditEvent[], name: BehaviorEventName) {
  const action = behaviorActionFor(name);

  return events.some((event) => event.behaviorEvent === name || event.action === action);
}
